import React from 'react';
import { connect, DispatchProp } from 'react-redux';

import { CharacterTheme, rulesEngineSelectors } from '@dndbeyond/character-rules-engine/es';

import { sidebarActions } from '../../../../Shared/actions';
import { appEnvSelectors } from '../../../../Shared/selectors';
import { PaneComponentEnum } from '../../../../Shared/utils';
import SubsectionTablet from '../../../components/SubsectionTablet';
import TabletBox from '../../../components/TabletBox';
import { SheetAppState } from '../../../typings';
import Extras from '../../Extras';

interface Props extends DispatchProp {
    isReadonly: boolean;
    theme: CharacterTheme;
}
class ExtrasTablet extends React.PureComponent<Props> {
    handleManageOpen = (): void => {
        const { dispatch, isReadonly } = this.props;

        if (!isReadonly) {
            dispatch(sidebarActions.paneHistoryStart(PaneComponentEnum.EXTRA_MANAGE));
        }
    };

    render() {
        const { isReadonly, theme } = this.props;

        return (
            <SubsectionTablet>
                <TabletBox
                    header="Extras"
                    onHeaderClick={this.handleManageOpen}
                    className="ct-extras-tablet"
                    isReadonly={isReadonly}
                    theme={theme}
                >
                    <Extras />
                </TabletBox>
            </SubsectionTablet>
        );
    }
}

function mapStateToProps(state: SheetAppState) {
    return {
        isReadonly: appEnvSelectors.getIsReadonly(state),
        theme: rulesEngineSelectors.getCharacterTheme(state),
    };
}

export default connect(mapStateToProps)(ExtrasTablet);
